import React from "react";
import Header from "components/UI/Header/Header";

export default function HeaderWrapper({ ...props }) {
  const newProps={forceChangeOptins:true, ...props} ;
  return <Header  {...newProps} />;
}
